enum AdviserListDisplayMode {
    Full = 0,
    DescriptionOnly = 1
}

export default AdviserListDisplayMode;
